import { render } from "./menuConfogV2.vue?vue&type=template&id=ec9da298&scoped=true&ts=true"
import script from "./menuConfogV2.vue?vue&type=script&lang=ts"
export * from "./menuConfogV2.vue?vue&type=script&lang=ts"

import "./menuConfogV2.vue?vue&type=style&index=0&id=ec9da298&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec9da298"]])

export default __exports__